import React from 'react';
import { Icon } from 'antd';
import { dayFormatType, formatDay } from '~helpers/day';
import formatPrice from '~helpers/currency';
import Card from '../card';
import { startCase } from 'lodash';

export default function BookingInfo({
  t,
  showExtra = false,
  bookingInfo = {},
  setVisibleModal = () => {},
}) {
  const bookingInfoFields = [
    {
      label: 'Actual Move-in Date',
      value: bookingInfo?.moveInDate
        ? formatDay(dayFormatType.UKFORMAT, bookingInfo.moveInDate)
        : '-',
    },
    {
      label: 'Actual Move-out Date',
      value: bookingInfo?.moveOutDate
        ? formatDay(dayFormatType.UKFORMAT, bookingInfo.moveOutDate)
        : '-',
    },
    {
      label: 'Total Rent',
      value: bookingInfo?.totalRental
        ? formatPrice(bookingInfo.totalRental, bookingInfo.currency)
        : '-',
    },
    {
      label: 'Booking Status',
      value: bookingInfo?.stage ? startCase(bookingInfo.stage.toLowerCase()) : '-',
    },
  ];

  return (
    <Card
      title={t('cms.reconciliation.lead_generation.detail.booking_info.title')}
      dataSet={bookingInfoFields}
      extra={
        showExtra && (
          <Icon onClick={() => setVisibleModal(true)} type="edit" style={{ color: '#38b2a6' }} />
        )
      }
    />
  );
}
